<script>
export default {
  computed: {

    currentPapers() {
      return this.$store.state.contribution.currentContributions
     
    },
  },
  created() {

    // 获取用户信息，注意由于mixins是可能混入多个组件的，也就是如果多处注册
    // 每个组件挂载时都会调用dispatch。好在下面的action里如果发现currentUser有的话，就直接返回
    // 希望vuex的actions也是成队列的，不然会多次请求后台获取
    const p1 =  this.$store.dispatch('conference/getCurrentConference').then((res) => {return res})
    const p2 =  this.$store.dispatch('user/getUserInfo').then((res) => {return res})

    Promise.all([p1, p2]).then((values) => {
        //console.log(values[1].id)
        this.$store.dispatch('contribution/getCurrentContributions',{userid:values[1].id,id:values[0].id}).then(() => {})
    });

  }
}
</script>